/* eslint-disable  */

import katex from 'katex';
export const IC = {
  back:      'M19 12H5M12 5l-7 7 7 7',
  edit:      'M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z',
  eye:       'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6',
  split:     'M3 3h8v18H3zM13 3h8v18h-8z',
  save:      'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2zM17 21v-8H7v8M7 3v5h8',
  send:      'M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z',
  book:      'M4 19.5A2.5 2.5 0 0 1 6.5 17H20M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z',
  plus:      'M12 5v14M5 12h14',
  trash:     'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6',
  x:         'M18 6L6 18M6 6l12 12',
  chevD:     'M6 9l6 6 6-6',
  chevU:     'M18 15l-6-6-6 6',
  chevR:     'M9 18l6-6-6-6',
  chevL:     'M15 18l-6-6 6-6',
  info:      'M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM12 8h.01M12 12v4',
  image:     'M21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3l2-3h4l2 3h3a2 2 0 0 1 2 2zM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6',
  video:     'M23 7l-7 5 7 5V7zM1 5h15v14H1z',
  link:      'M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71',
  code:      'M16 18l6-6-6-6M8 6l-6 6 6 6',
  bold:      'M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6zM6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z',
  italic:    'M19 4h-9M14 20H5M14.7 4.7L9.3 19.3',
  list:      'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  table:     'M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18',
  quote:     'M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.031V20c0 1 0 1 1 1zm12 0c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 0 1 1 1z',
  hr:        'M5 12h14',
  btn:       'M4 9h16a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z',
  warning:   'M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4M12 17h.01',
  upload:    'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12',
  formula:   'M4 7h16M4 12h10M4 17h16',
  sigma:     'M18 4H6l6 8-6 8h12',
  palette:   'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8z',
  text:      'M4 7V4h16v3M9 20h6M12 4v16',
  math:      'M3 3h4l4 14 4-10 2 6h4',
  chemistry: 'M9 3H5v4l7 7 7-7V3h-4M9 3l3 4 3-4',
  physics:   'M13 10V3L4 14h7v7l9-11h-7z',
  biology:   'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
  computer:  'M2 3h20v14H2zM8 21h8M12 17v4',
  exam:      'M9 11l3 3L22 4M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11',
  general:   'M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5',
  lifecycle: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0zM12 8v4l3 3',
  color:     'M12 2a10 10 0 1 0 10 10M12 2v10l6.36 6.36',
  heading:   'M4 6h16M4 12h8M4 18h16',
  strikeS:   'M5 12h14M12 6v12',
  inlineC:   'M8 9l-4 3 4 3M16 9l4 3-4 3M12 5l-2 14',
  numbList:  'M11 6h9M11 12h9M11 18h9M4 6v.01M4 12v.01M4 18v.01',
  divider:   'M3 12h18',
  callout:   'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',
  jee:       'M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18',
  pencil:    'M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 1 1 3.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z',
  star:      'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',
  cycle:     'M4 4v5h.582m15.356 2A8.001 8.001 0 0 0 4.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 0 1-15.357-2m15.357 2H15',
};

// ─── Metadata Options ─────────────────────────────────────────────────────────
export const SUBJECTS = ['Biology','Physics','Chemistry','Mathematics','History','Geography','Computer Science','English','Economics','Accountancy','Business Studies','Political Science','Sociology','Psychology'];
export const CLASS_LEVELS = ['LKG','UKG','Class 1','Class 2','Class 3','Class 4','Class 5','Class 6','Class 7','Class 8','Class 9','Class 10','Class 11','Class 12','Undergraduate','Postgraduate'];
export const LANGUAGES = ['English','Hindi','Tamil','Telugu','Kannada','Malayalam','Marathi','Bengali','Gujarati','Punjabi'];
export const BOARDS = ['CBSE','ICSE','State Board','IB','Cambridge','NEET','JEE','Other'];

// ─── Text Color Palette ───────────────────────────────────────────────────────
export const TEXT_COLORS = [
  { label: 'Default',    color: null },
  { label: 'Red',       color: '#dc2626' },
  { label: 'Orange',    color: '#ea580c' },
  { label: 'Amber',     color: '#d97706' },
  { label: 'Green',     color: '#16a34a' },
  { label: 'Teal',      color: '#0d9488' },
  { label: 'Blue',      color: '#2563eb' },
  { label: 'Indigo',    color: '#4f46e5' },
  { label: 'Purple',    color: '#9333ea' },
  { label: 'Pink',      color: '#db2777' },
  { label: 'Gray',      color: '#6b7280' },
  { label: 'Black',     color: '#0f172a' },
];

export const HIGHLIGHT_COLORS = [
  { label: 'None',      color: null },
  { label: 'Yellow',    color: '#fef08a' },
  { label: 'Green',     color: '#bbf7d0' },
  { label: 'Blue',      color: '#bfdbfe' },
  { label: 'Pink',      color: '#fbcfe8' },
  { label: 'Orange',    color: '#fed7aa' },
  { label: 'Purple',    color: '#e9d5ff' },
];

// ─── Preview CSS ──────────────────────────────────────────────────────────────
export const PREVIEW_CSS = `
.ebk h1{font-size:2rem;font-weight:800;color:#0f172a;margin-bottom:1rem;border-bottom:3px solid #6366f1;padding-bottom:.5rem;letter-spacing:-.02em}
.ebk h2{font-size:1.5rem;font-weight:700;color:#1e293b;margin-top:2.5rem;margin-bottom:.75rem;padding-left:.75rem;border-left:4px solid #6366f1}
.ebk h3{font-size:1.2rem;font-weight:600;color:#334155;margin-top:1.75rem;margin-bottom:.5rem}
.ebk p{margin-bottom:1rem;color:#374151;line-height:1.85;font-size:1rem}
.ebk ul,.ebk ol{padding-left:1.75rem;margin-bottom:1rem}
.ebk li{margin-bottom:.35rem;color:#374151;line-height:1.7}
.ebk strong{font-weight:700;color:#0f172a}
.ebk em{font-style:italic;color:#475569}
.ebk a{color:#6366f1;text-decoration:underline;text-underline-offset:2px}
.ebk hr{border:none;border-top:2px dashed #e2e8f0;margin:2.5rem 0}
.ebk blockquote{border-left:4px solid #6366f1;padding:.875rem 1.25rem;background:linear-gradient(to right,#f0f9ff,#fff);margin:1.5rem 0;border-radius:0 .75rem .75rem 0;font-style:italic;color:#475569}
.ebk code{background:#f1f5f9;color:#dc2626;padding:.125rem .375rem;border-radius:.3rem;font-size:.875em;font-family:'Fira Code',monospace}
.ebk pre{background:#0f172a;color:#e2e8f0;padding:1.5rem;border-radius:.75rem;overflow-x:auto;margin-bottom:1.25rem;box-shadow:0 4px 24px rgba(0,0,0,.2)}
.ebk pre code{background:transparent;color:#e2e8f0;padding:0;font-size:.875rem}
.ebk table{width:100%;border-collapse:collapse;margin-bottom:1.25rem;border-radius:.75rem;overflow:hidden;box-shadow:0 1px 8px rgba(0,0,0,.06)}
.ebk th{background:#6366f1;color:#fff;padding:.75rem 1rem;text-align:left;font-weight:600;font-size:.9rem}
.ebk td{padding:.625rem 1rem;border-bottom:1px solid #f1f5f9;font-size:.9rem}
.ebk tr:nth-child(even) td{background:#f8fafc}
.ebk img{max-width:100%;border-radius:.75rem;margin:1rem auto;display:block;box-shadow:0 4px 20px rgba(0,0,0,.1)}
/* A figure's text-align only reaches a block-level child through an auto
   margin, so media inside one is inline-block with flush margins. Both the
   .ebk-fig class this editor writes and the bare inline text-align that older
   and imported content carries are matched, so alignment works on every shape. */
.ebk .ebk-fig img,.ebk .ebk-fig video,.ebk div[style*="text-align"] img,.ebk div[style*="text-align"] video{display:inline-block;margin:1rem 0;vertical-align:top}
.ebk iframe{border-radius:.75rem;margin:1rem 0;box-shadow:0 4px 20px rgba(0,0,0,.08)}
.callout{border-left:4px solid;padding:1rem 1.25rem;border-radius:0 .75rem .75rem 0;margin:1.25rem 0;font-size:.95rem}
.callout-tip{background:#f0fdf4;border-color:#22c55e;color:#14532d}
.callout-warning{background:#fffbeb;border-color:#f59e0b;color:#78350f}
.callout-definition{background:#eff6ff;border-color:#3b82f6;color:#1e3a8a}
.callout-important{background:#fef2f2;border-color:#ef4444;color:#7f1d1d}
.callout-remember{background:#f5f3ff;border-color:#8b5cf6;color:#3b0764}
.callout-title{font-weight:700;margin-bottom:.35rem;font-size:.9rem;letter-spacing:.03em}
.ebook-btn{display:inline-flex;align-items:center;padding:.6rem 1.25rem;border-radius:.5rem;font-weight:600;font-size:.9rem;text-decoration:none;cursor:pointer;transition:opacity .2s}
.ebook-btn:hover{opacity:.85}
.ebook-video-wrap{position:relative;border-radius:.75rem;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,.1);margin:1.25rem 0;background:#000}
.callout-solved{background:#f0fdf4;border-color:#16a34a;color:#14532d}
.callout-mcq{background:#faf5ff;border-color:#7c3aed;color:#3b0764}
.callout-formula{background:#eff6ff;border-color:#2563eb;color:#1e3a8a}
.callout-mistakes{background:#fff7ed;border-color:#ea580c;color:#7c2d12}
.callout-steps{background:#f0f9ff;border-color:#0284c7;color:#0c4a6e}
.callout-theorem{background:#fdf4ff;border-color:#a855f7;color:#3b0764}
.callout-proof{background:#f0fdf4;border-color:#15803d;color:#14532d}
.callout-lemma{background:#fffbeb;border-color:#ca8a04;color:#78350f}
.callout-corollary{background:#f0f9ff;border-color:#0ea5e9;color:#0c4a6e}
.callout-reaction{background:#fff7ed;border-color:#f97316;color:#7c2d12}
.callout-mechanism{background:#fdf4ff;border-color:#c026d3;color:#4a044e}
.callout-experiment{background:#f0fdf4;border-color:#22c55e;color:#14532d}
.callout-law{background:#eff6ff;border-color:#3b82f6;color:#1e3a8a}
.callout-derivation{background:#fdf2f8;border-color:#ec4899;color:#831843}
.callout-pyq{background:#fef3c7;border-color:#f59e0b;color:#78350f}
.callout-casestudy{background:#f0f9ff;border-color:#0284c7;color:#0c4a6e}
.callout-lifecycle{background:#ecfdf5;border-color:#10b981;color:#064e3b}
.callout-organism{background:#f0fdf4;border-color:#16a34a;color:#14532d}
.callout-summary{background:#f8fafc;border-color:#94a3b8;color:#1e293b}
.callout-objectives{background:#eff6ff;border-color:#6366f1;color:#1e3a8a}
.callout-vocab{background:#fdf4ff;border-color:#a855f7;color:#3b0764}
.callout-didyouknow{background:#ecfdf5;border-color:#06b6d4;color:#164e63}
.callout-realworld{background:#fff7ed;border-color:#f97316;color:#7c2d12}
.callout-analogy{background:#f5f3ff;border-color:#8b5cf6;color:#3b0764}
.callout-misconception{background:#fef2f2;border-color:#ef4444;color:#7f1d1d}
.callout-algorithm{background:#0f172a;border-color:#6366f1;color:#e2e8f0;font-family:'Fira Code',monospace}
.katex-block{margin:1.25rem 0;padding:.75rem 1rem;background:#f8fafc;border-radius:.5rem;overflow-x:auto;text-align:center}
.lifecycle-wrap{margin:1.5rem 0;padding:1.25rem;background:#f0fdf4;border:1px solid #bbf7d0;border-radius:.75rem}
.lifecycle-title{font-weight:800;font-size:1rem;color:#065f46;margin-bottom:1rem;display:flex;align-items:center;gap:.5rem}
.lifecycle-steps{display:flex;flex-wrap:wrap;gap:.75rem;align-items:center}
.lifecycle-step{display:flex;flex-direction:column;align-items:center;gap:.4rem;min-width:90px;max-width:120px}
.lifecycle-step-img{width:80px;height:80px;border-radius:50%;object-fit:cover;border:3px solid #10b981;background:#d1fae5;display:flex;align-items:center;justify-content:center;font-size:2rem}
.lifecycle-step-num{font-size:.65rem;font-weight:700;color:#10b981;background:#d1fae5;border-radius:999px;padding:.1rem .5rem}
.lifecycle-step-name{font-size:.75rem;font-weight:600;color:#065f46;text-align:center;line-height:1.3}
.lifecycle-arrow{color:#10b981;font-size:1.25rem;font-weight:700;flex-shrink:0;align-self:flex-start;margin-top:28px}
`;

// ─── Callout Meta ─────────────────────────────────────────────────────────────
export const CALLOUT_META = {
  tip:          { label: '💡 Tip' },
  warning:      { label: '⚠️ Warning' },
  definition:   { label: '📖 Definition' },
  important:    { label: '🔴 Important' },
  remember:     { label: '🟣 Remember' },
  solved:       { label: '✅ Solved Example' },
  mcq:          { label: '🎯 Practice MCQ' },
  formula:      { label: '🔢 Formula' },
  mistakes:     { label: '❌ Common Mistakes' },
  steps:        { label: '📋 Step-by-step' },
  theorem:      { label: '📐 Theorem' },
  proof:        { label: '🧮 Proof' },
  lemma:        { label: '🔷 Lemma' },
  corollary:    { label: '➡️ Corollary' },
  reaction:     { label: '⚗️ Chemical Reaction' },
  mechanism:    { label: '🔬 Mechanism' },
  experiment:   { label: '🧪 Experiment' },
  law:          { label: '⚖️ Law / Principle' },
  derivation:   { label: '📊 Derivation' },
  pyq:          { label: '📝 Previous Year Q' },
  casestudy:    { label: '📂 Case Study' },
  lifecycle:    { label: '🔄 Life Cycle' },
  organism:     { label: '🌿 Organism' },
  summary:      { label: '📋 Summary' },
  objectives:   { label: '🎯 Learning Objectives' },
  vocab:        { label: '📚 Vocabulary' },
  didyouknow:   { label: '🤔 Did You Know?' },
  realworld:    { label: '🌍 Real World' },
  analogy:      { label: '💭 Analogy' },
  misconception:{ label: '🚫 Misconception' },
  algorithm:    { label: '⚙️ Algorithm' },
};

// ─── Block parsers ─────────────────────────────────────────────────────────────
function parseBlockProps(body) {
  const result = {};
  body.trim().split('\n').forEach((line) => {
    const eq = line.indexOf('=');
    if (eq !== -1) result[line.slice(0, eq).trim()] = line.slice(eq + 1).trim();
  });
  return result;
}

// Markdown is never parsed inside a raw HTML element, so anywhere this file
// promotes a line into HTML it has to carry the inline markers across itself.
// Tags are masked out first so a stray marker next to one — "*<span …>*" — can
// never be read as emphasis and split the tag open. Emphasis may still span a
// tag, because a mask is just one more character to cross. A run that turns out
// to hold nothing but tags is left exactly as it was: there is no text to style,
// and rewriting it would only move the markers somewhere worse.
const inlineMdToHtml = (s) => {
  const tags = [];
  const masked  = s.replace(/<[^>]+>/g, (t) => `\u0000${tags.push(t) - 1}\u0000`);
  const hasText = (b) => b.replace(/\u0000\d+\u0000/g, '').trim() !== '';
  const styled = masked
    .replace(/\*\*\*(.+?)\*\*\*/g, (m, b) => (hasText(b) ? `<strong><em>${b}</em></strong>` : m))
    .replace(/\*\*(.+?)\*\*/g, (m, b) => (hasText(b) ? `<strong>${b}</strong>` : m))
    .replace(/(^|[^*])\*([^*\n]+?)\*/g, (m, p, b) => (hasText(b) ? `${p}<em>${b}</em>` : m))
    .replace(/~~(.+?)~~/g, (m, b) => (hasText(b) ? `<del>${b}</del>` : m))
    .replace(/`([^`]+?)`/g, (m, b) => (hasText(b) ? `<code>${b}</code>` : m));
  return styled.replace(/\u0000(\d+)\u0000/g, (_, i) => tags[Number(i)]);
};


export function processCustomBlocks(md) {
  // LaTeX block
  let out = md.replace(/\$\$([\s\S]+?)\$\$/g, (_, tex) => {
    try { return `<div class="katex-block">${katex.renderToString(tex.trim(), { displayMode: true, throwOnError: false })}</div>`; }
    catch { return `<div class="katex-block"><code>${tex}</code></div>`; }
  });
  // LaTeX inline
  out = out.replace(/\$([^$\n]+?)\$/g, (_, tex) => {
    try { return katex.renderToString(tex.trim(), { displayMode: false, throwOnError: false }); }
    catch { return `<code>${tex}</code>`; }
  });

  // Colour and highlight resolve innermost-pair-first, repeated until stable, so
  // colour over highlight and highlight over colour both work in either order.
  // A body that is non-empty and holds no further ':::' opener is the innermost.
  const COLOUR_RE    = /:::color\[([^\]]+)\]((?:(?!:::)[\s\S])+):::/g;
  const HIGHLIGHT_RE = /:::highlight\[([^\]]+)\]((?:(?!:::)[\s\S])+):::/g;
  const HILITE_CSS   = (c) => `background:${c};border-radius:3px;padding:0 3px`;
  const resolveStyled = (text, emit) => {
    let prev;
    let s = text;
    do {
      prev = s;
      s = s.replace(COLOUR_RE, (_, c, b) => emit(b, `color:${c}`))
           .replace(HIGHLIGHT_RE, (_, c, b) => emit(b, HILITE_CSS(c)));
    } while (s !== prev);
    return s;
  };

  // Inside an alignment wrapper the content is already raw HTML, so a <span>
  // works there and markdown does not — the opposite of everywhere else. The
  // .docx importer writes every centred Word paragraph as one of these, so this
  // runs FIRST: converting those to links instead would print the link syntax.
  const spanEmit = (body, css) => `<span style="${css}">${body.trim()}</span>`;
  out = out.replace(/(<div[^>]*text-align[^>]*>)([\s\S]*?)(<\/div>)/g,
    (_, open, body, close) => open + inlineMdToHtml(resolveStyled(body, spanEmit)) + close);

  // Everywhere else, colour is emitted as a link carrying the CSS in its href.
  // react-markdown v5 splits inline raw HTML into one node per tag, so a <span>
  // arrives as an opening tag, the text and a closing tag, and renders empty. A
  // link is a real markdown construct: parsed inline wherever markdown allows
  // one — paragraphs, headings, bullets, table cells, blockquotes — with its
  // text still parsed, so bold inside a coloured phrase keeps working.
  // MarkdownPreview's `link` renderer turns this href back into a styled span.
  // The two styles merge into one link because markdown cannot nest links.
  // A link cannot contain another link, so when the body already holds one the
  // style is merged into it and only the bare text around it is wrapped. Without
  // this, colouring a span that already carries a colour emitted [..[..]..](..)
  // and markdown printed the whole thing as text.
  const KSS_LINK = /\[([\s\S]*?)\]\(#kss-style=([^)]*)\)/g;
  const wrapPlain = (text, css) =>
    `[${text.replace(/([[\]])/g, '\\' + '$1')}](#kss-style=${encodeURIComponent(css)})`;
  const linkEmit = (raw, css) => {
    const body = raw.trim();
    KSS_LINK.lastIndex = 0;
    if (!KSS_LINK.test(body)) return wrapPlain(body, css);
    KSS_LINK.lastIndex = 0;
    let result = '';
    let last = 0;
    let m = KSS_LINK.exec(body);
    while (m !== null) {
      const gap = body.slice(last, m.index);
      result += gap.trim() ? wrapPlain(gap, css) : gap;
      // Inner declarations come last so they win on any shared property.
      result += `[${m[1]}](#kss-style=${encodeURIComponent(`${css};${decodeURIComponent(m[2])}`)})`;
      last = m.index + m[0].length;
      m = KSS_LINK.exec(body);
    }
    const tail = body.slice(last);
    result += tail.trim() ? wrapPlain(tail, css) : tail;
    return result;
  };
  out = resolveStyled(out, linkEmit);


  // Lifecycle blocks
  out = out.replace(/:::lifecycle\n([\s\S]*?):::/g, (_, body) => {
    const lines  = body.trim().split('\n');
    const config = {};
    const stages = [];
    lines.forEach((ln) => {
      if (ln.startsWith('title='))   config.title   = ln.slice(6).trim();
      else if (ln.startsWith('circular=')) config.circular = ln.slice(9).trim() === 'true';
      else if (ln.match(/^\d+\./)) {
        const rest  = ln.replace(/^\d+\.\s*/, '');
        const parts = rest.split('|');
        stages.push({ name: parts[0]?.trim() || '', emoji: parts[1]?.trim() || '🔵', img: parts[2]?.trim() || '' });
      }
    });
    const titleHtml = config.title ? `<div class="lifecycle-title">🔄 ${config.title}</div>` : '';
    const stepsHtml = stages.map((s, i) => {
      const imgEl = s.img
        ? `<img src="${s.img}" alt="${s.name}" class="lifecycle-step-img" style="width:80px;height:80px;border-radius:50%;object-fit:cover;border:3px solid #10b981" />`
        : `<div class="lifecycle-step-img" style="width:80px;height:80px;border-radius:50%;background:#d1fae5;display:flex;align-items:center;justify-content:center;font-size:2rem">${s.emoji}</div>`;
      const arrow  = (i < stages.length - 1) ? `<div class="lifecycle-arrow">→</div>` : (config.circular ? `<div class="lifecycle-arrow">↺</div>` : '');
      return `<div class="lifecycle-step">${imgEl}<div class="lifecycle-step-num">Step ${i + 1}</div><div class="lifecycle-step-name">${s.name}</div></div>${arrow}`;
    }).join('');
    return `<div class="lifecycle-wrap">${titleHtml}<div class="lifecycle-steps">${stepsHtml}</div></div>`;
  });

  // Video blocks
  out = out.replace(/:::video\n([\s\S]*?):::/g, (_, body) => {
    const p = parseBlockProps(body);
    return `<div class="ebook-video-wrap"><iframe src="${p.url || ''}" width="${p.width || '100%'}" height="${p.height || '360'}" title="${p.title || 'Video'}" frameborder="0" allowfullscreen style="width:${p.width || '100%'};display:block;"></iframe></div>`;
  });

  // Button blocks
  out = out.replace(/:::button\n([\s\S]*?):::/g, (_, body) => {
    const p     = parseBlockProps(body);
    const bg    = p.color || '#6366f1';
    const fg    = p.textColor || '#ffffff';
    let px;
    if (p.size === 'small') px = '.4rem .9rem';
    else if (p.size === 'large') px = '.875rem 2rem';
    else px = '.625rem 1.5rem';
    const radius = `${p.radius || 8}px`;
    const align  = p.align === 'center' ? 'center' : p.align === 'right' ? 'right' : 'left';
    return `<div style="text-align:${align};margin:1.25rem 0"><a href="${p.url || '#'}" target="_blank" rel="noreferrer" class="ebook-btn" style="background:${bg};color:${fg};padding:${px};border-radius:${radius}">${p.label || 'Click here'}</a></div>`;
  });

  // Generic callout blocks
  out = out.replace(/:::(\w+)\n([\s\S]*?):::/g, (_, type, body) => {
    const meta = CALLOUT_META[type];
    if (!meta) return `<div>${body}</div>`;
    return `<div class="callout callout-${type}"><div class="callout-title">${meta.label}</div>${body.trim()}</div>`;
  });

  return out;
}

// ─── Full Template Library (110+ templates) ───────────────────────────────────
// Each template: { label, title, insert, icon? }

// ── FORMAT GROUP ──────────────────────────────────────────────────────────────
export const GROUP_FORMAT = {
  key: 'format', label: 'Format', icon: IC.text,
  items: [
    { label: 'H1',  title: 'Heading 1',       wrap: '# ',   block: true, icon: IC.heading },
    { label: 'H2',  title: 'Heading 2',        wrap: '## ',  block: true, icon: IC.heading },
    { label: 'H3',  title: 'Heading 3',        wrap: '### ', block: true, icon: IC.heading },
    { label: 'B',   title: 'Bold',             wrap: '**',   icon: IC.bold },
    { label: 'I',   title: 'Italic',           wrap: '_',    icon: IC.italic },
    { label: 'S',   title: 'Strikethrough',    wrap: '~~',   icon: IC.strikeS },
    { label: '`',   title: 'Inline Code',      wrap: '`',    icon: IC.inlineC },
    { label: '$',   title: 'Inline Formula',   wrap: '$',    icon: IC.sigma },
    { label: '$$',  title: 'Block Formula',    insert: '\n$$\n\\frac{a}{b}\n$$\n', icon: IC.formula },
    { label: 'HR',  title: 'Divider',          insert: '\n---\n', icon: IC.divider },
    { label: 'Link',title: 'Link',             insert: '[Link text](https://)', icon: IC.link },
  ],
};

// ── BLOCKS GROUP ──────────────────────────────────────────────────────────────
export const GROUP_BLOCKS = {
  key: 'blocks', label: 'Blocks', icon: IC.list,
  items: [
    { label: 'Bullet',    title: 'Bullet List',    insert: '\n- Item 1\n- Item 2\n- Item 3\n', icon: IC.list },
    { label: 'Numbered',  title: 'Numbered List',  insert: '\n1. First\n2. Second\n3. Third\n', icon: IC.numbList },
    { label: 'Quote',     title: 'Blockquote',     insert: '\n> Quote here\n', icon: IC.quote },
    { label: 'Code',      title: 'Code Block',     insert: '\n```js\n// code here\n```\n', icon: IC.code },
    { label: 'Table',     title: 'Table',          insert: '\n| Col 1 | Col 2 | Col 3 |\n|-------|-------|-------|\n| A | B | C |\n', icon: IC.table },
    { label: 'Callout',   title: 'Tip Callout',    insert: '\n:::tip\nYour tip here\n:::\n', icon: IC.callout },
    { label: 'Warning',   title: 'Warning Block',  insert: '\n:::warning\nWarning message\n:::\n', icon: IC.warning },
    { label: 'Definition',title: 'Definition',     insert: '\n:::definition\n**Term**: Explanation\n:::\n', icon: IC.book },
    { label: 'Important', title: 'Important',      insert: '\n:::important\nKey point\n:::\n', icon: IC.star },
    { label: 'Remember',  title: 'Remember',       insert: '\n:::remember\nThing to remember\n:::\n', icon: IC.info },
  ],
};

// ── MATHEMATICS GROUP ─────────────────────────────────────────────────────────
export const GROUP_MATH = {
  key: 'math', label: 'Mathematics', icon: IC.math,
  items: [
    {
      label: 'Theorem', title: 'Theorem Block',
      insert: '\n:::theorem\n**Theorem:** State the theorem here.\n\n$$\nf(x) = \\lim_{h \\to 0} \\frac{f(x+h)-f(x)}{h}\n$$\n:::\n',
    },
    {
      label: 'Proof', title: 'Formal Proof',
      insert: '\n:::proof\n**Proof:**\n\nLet us assume that...\n\n**Step 1:** First step\n\n$$\n\\text{formula here}\n$$\n\n**Step 2:** Second step\n\nHence proved. $\\blacksquare$\n:::\n',
    },
    {
      label: 'Lemma', title: 'Lemma Block',
      insert: '\n:::lemma\n**Lemma:** State the lemma here.\n\n*Proof:* Brief justification here.\n:::\n',
    },
    {
      label: 'Corollary', title: 'Corollary Block',
      insert: '\n:::corollary\n**Corollary:** This follows directly from the theorem above.\n\n$$\n\\text{result here}\n$$\n:::\n',
    },
    {
      label: 'Formula Box', title: 'Formula Box',
      insert: '\n:::formula\n$$\nF = ma\n$$\n\n**Where:**\n- $F$ = Force (N)\n- $m$ = Mass (kg)\n- $a$ = Acceleration (m/s²)\n:::\n',
    },
    {
      label: 'Derivation', title: 'Formula Derivation',
      insert: '\n:::derivation\n**Deriving:** Name of formula\n\nStarting from first principles:\n\n$$\n\\text{Step 1: starting equation}\n$$\n\n$$\n\\text{Step 2: manipulation}\n$$\n\n$$\n\\boxed{\\text{Final Result}}\n$$\n:::\n',
    },
    {
      label: 'Worked (Algebra)', title: 'Worked Example – Algebra',
      insert: '\n:::solved\n**Problem:** Solve $2x^2 - 5x + 3 = 0$\n\n**Method:** Factorisation / Quadratic Formula\n\n**Solution:**\n\n$$\nx = \\frac{-b \\pm \\sqrt{b^2-4ac}}{2a}\n$$\n\nSubstitute $a=2, b=-5, c=3$:\n\n$$\nx = \\frac{5 \\pm \\sqrt{25-24}}{4} = \\frac{5 \\pm 1}{4}\n$$\n\n**Answer:** $x = \\frac{3}{2}$ or $x = 1$\n:::\n',
    },
    {
      label: 'Worked (Calculus)', title: 'Worked Example – Calculus',
      insert: '\n:::solved\n**Problem:** Differentiate $f(x) = x^3 \\sin x$\n\n**Method:** Product Rule — $\\frac{d}{dx}[uv] = u\'v + uv\'$\n\n**Solution:**\n\nLet $u = x^3$ and $v = \\sin x$\n\n$$\nu\' = 3x^2,\\quad v\' = \\cos x\n$$\n\n$$\nf\'(x) = 3x^2 \\sin x + x^3 \\cos x\n$$\n\n**Answer:** $f\'(x) = x^2(3\\sin x + x\\cos x)$\n:::\n',
    },
    {
      label: 'Worked (Trig)', title: 'Worked Example – Trigonometry',
      insert: '\n:::solved\n**Problem:** Prove that $\\sin^2\\theta + \\cos^2\\theta = 1$\n\n**Solution:**\n\nIn a right-angled triangle with hypotenuse $r$:\n\n$$\n\\sin\\theta = \\frac{y}{r},\\quad \\cos\\theta = \\frac{x}{r}\n$$\n\nBy Pythagoras: $x^2 + y^2 = r^2$\n\n$$\n\\therefore \\frac{x^2}{r^2} + \\frac{y^2}{r^2} = 1 \\implies \\cos^2\\theta + \\sin^2\\theta = 1\n$$\n\nHence proved. $\\blacksquare$\n:::\n',
    },
    {
      label: 'Worked (Matrix)', title: 'Worked Example – Matrices',
      insert: '\n:::solved\n**Problem:** Find the inverse of $A = \\begin{pmatrix}2&1\\\\5&3\\end{pmatrix}$\n\n**Solution:**\n\n$$\n\\det(A) = (2)(3)-(1)(5) = 1\n$$\n\n$$\nA^{-1} = \\frac{1}{\\det(A)}\\begin{pmatrix}3&-1\\\\-5&2\\end{pmatrix} = \\begin{pmatrix}3&-1\\\\-5&2\\end{pmatrix}\n$$\n\n**Verify:** $AA^{-1} = I$ ✓\n:::\n',
    },
    {
      label: 'Worked (Probability)', title: 'Worked Example – Probability',
      insert: '\n:::solved\n**Problem:** A bag has 4 red, 3 blue balls. Two are drawn without replacement. Find P(both red).\n\n**Solution:**\n\n$$\nP(\\text{both red}) = \\frac{\\binom{4}{2}}{\\binom{7}{2}} = \\frac{6}{21} = \\frac{2}{7}\n$$\n\n**Answer:** $P = \\dfrac{2}{7} \\approx 0.286$\n:::\n',
    },
    {
      label: 'Worked (Statistics)', title: 'Worked Example – Statistics',
      insert: '\n:::solved\n**Problem:** Find mean and standard deviation of: 4, 7, 9, 10, 5\n\n**Solution:**\n\n$$\n\\bar{x} = \\frac{4+7+9+10+5}{5} = 7\n$$\n\n$$\n\\sigma = \\sqrt{\\frac{\\sum(x_i-\\bar{x})^2}{n}} = \\sqrt{\\frac{9+0+4+9+4}{5}} = \\sqrt{5.2} \\approx 2.28\n$$\n:::\n',
    },
    {
      label: 'Inequality', title: 'Inequality Solution',
      insert: '\n:::steps\n**Solve:** $3x - 7 > 2$\n\n**Step 1:** Add 7 to both sides\n$$\n3x > 9\n$$\n\n**Step 2:** Divide by 3\n$$\nx > 3\n$$\n\n**Solution set:** $(3, \\infty)$\n:::\n',
    },
    {
      label: 'Sequence', title: 'Sequence & Series',
      insert: '\n:::formula\n**Arithmetic Progression (AP)**\n\n- General term: $a_n = a + (n-1)d$\n- Sum of $n$ terms: $S_n = \\dfrac{n}{2}[2a + (n-1)d]$\n\n**Geometric Progression (GP)**\n\n- General term: $a_n = ar^{n-1}$\n- Sum of $n$ terms: $S_n = \\dfrac{a(r^n-1)}{r-1}$ for $r \\neq 1$\n:::\n',
    },
    {
      label: 'MCQ (Math)', title: 'Math MCQ',
      insert: '\n:::mcq\n**Q.** If $\\sin\\theta = \\frac{3}{5}$, find $\\cos\\theta$.\n\n(A) $\\dfrac{4}{5}$\n\n(B) $\\dfrac{3}{4}$\n\n(C) $\\dfrac{5}{4}$\n\n(D) $\\dfrac{2}{5}$\n\n:::remember\n**Answer:** (A) $\\dfrac{4}{5}$\n\nUsing $\\cos^2\\theta = 1 - \\sin^2\\theta = 1 - \\dfrac{9}{25} = \\dfrac{16}{25}$\n:::\n:::\n',
    },
    {
      label: 'Assertion-Reason', title: 'Assertion-Reason (Math)',
      insert: '\n:::important\n**Assertion (A):** The function $f(x) = x^2$ is always non-negative.\n\n**Reason (R):** Square of any real number is non-negative.\n\n---\n\n*(A) Both A and R are true, and R is the correct explanation of A.*\n\n(B) Both A and R are true, but R is not the correct explanation of A.\n\n(C) A is true but R is false.\n\n(D) A is false but R is true.\n\n:::remember\n**Answer:** (A)\n:::\n:::\n',
    },
    {
      label: 'Comparison Table', title: 'Method Comparison Table',
      insert: '\n| Feature | Method 1 | Method 2 |\n|---------|----------|----------|\n| Name | Substitution | Elimination |\n| Best for | Single-variable | Multi-variable |\n| Steps | Isolate variable, substitute | Multiply & add equations |\n| Complexity | Low | Medium |\n',
    },
    {
      label: 'Truth Table', title: 'Truth Table (Logic)',
      insert: '\n| $P$ | $Q$ | $P \\land Q$ | $P \\lor Q$ | $\\lnot P$ |\n|-----|-----|------------|-----------|----------|\n| T | T | T | T | F |\n| T | F | F | T | F |\n| F | T | F | T | T |\n| F | F | F | F | T |\n',
    },
    {
      label: 'Number Line', title: 'Number Line Description',
      insert: '\n:::definition\n**Number Line:**\n\n```\n←—|—|—|—|—|—|—|—|—|—→\n  -4 -3 -2 -1  0  1  2  3  4\n              ↑\n           Origin\n```\n\nPositive numbers → right of zero | Negative numbers → left of zero\n:::\n',
    },
    {
      label: 'Complex Numbers', title: 'Complex Numbers Block',
      insert: '\n:::formula\n**Complex Number:** $z = a + bi$\n\n- **Modulus:** $|z| = \\sqrt{a^2 + b^2}$\n- **Argument:** $\\theta = \\tan^{-1}\\left(\\dfrac{b}{a}\\right)$\n- **Conjugate:** $\\bar{z} = a - bi$\n- **Polar form:** $z = r(\\cos\\theta + i\\sin\\theta) = re^{i\\theta}$\n:::\n',
    },
    {
      label: 'Venn Diagram', title: 'Venn Diagram (Sets)',
      insert: '\n:::definition\n**Set Operations — Venn Diagram:**\n\n```\n  Universe U\n  ┌─────────────────────────┐\n  │   ┌──────┐  ┌──────┐   │\n  │   │  A   │∩ │  B   │   │\n  │   │ only │AB│ only │   │\n  │   └──────┘  └──────┘   │\n  └─────────────────────────┘\n```\n\n- $A \\cup B$ = All elements in A or B\n- $A \\cap B$ = Elements in both A and B\n- $A - B$ = Elements in A but not B\n:::\n',
    },
  ],
};

// ── CHEMISTRY GROUP ───────────────────────────────────────────────────────────
export const GROUP_CHEMISTRY = {
  key: 'chemistry', label: 'Chemistry', icon: IC.chemistry,
  items: [
    {
      label: 'Reaction', title: 'Chemical Reaction Block',
      insert: '\n:::reaction\n**Reaction:** Name of reaction\n\n$$\n\\text{Reactant 1} + \\text{Reactant 2} \\xrightarrow{\\text{Conditions}} \\text{Product} + \\text{By-product}\n$$\n\n**Conditions:** Temperature, Catalyst, Pressure\n\n**Observations:** Colour change, gas evolution, precipitate\n:::\n',
    },
    {
      label: 'Mechanism', title: 'Organic Reaction Mechanism',
      insert: '\n:::mechanism\n**Mechanism:** SN2 (Bimolecular Nucleophilic Substitution)\n\n**Step 1 — Nucleophile attack:**\n$$\n\\text{Nu:}^- + \\text{R-X} \\rightarrow [\\text{Nu---R---X}]^\\ddagger \\rightarrow \\text{Nu-R} + \\text{X}^-\n$$\n\n**Rate:** $\\text{Rate} = k[\\text{RX}][\\text{Nu}]$ (2nd order)\n\n**Stereochemistry:** Inversion of configuration (Walden inversion)\n\n**Favoured by:** Primary alkyl halides, strong nucleophile, polar aprotic solvent\n:::\n',
    },
    {
      label: 'Organic Scheme', title: 'Organic Reaction Scheme',
      insert: '\n:::solved\n**Starting Material:** Name/Formula\n\n**Reagent:** Reagent + conditions\n\n**Product:** Name/Formula\n\n**Key points:**\n- Functional group converted: ...\n- Mechanism type: ...\n- Yield considerations: ...\n:::\n',
    },
    {
      label: 'IUPAC Naming', title: 'IUPAC Naming Walkthrough',
      insert: '\n:::steps\n**Compound:** Draw/write structure here\n\n**Step 1:** Identify the longest carbon chain (parent chain)\n→ Parent: ___ane / ___ene / ___yne\n\n**Step 2:** Number the chain to give substituents lowest locants\n\n**Step 3:** Identify and name substituents\n→ Substituents: methyl-, ethyl-, chloro-, etc.\n\n**Step 4:** Write name — locant + substituent + parent chain\n\n**IUPAC Name:** ___\n:::\n',
    },
    {
      label: 'Mole Concept', title: 'Mole Concept Worked',
      insert: '\n:::solved\n**Problem:** Find the number of molecules in 18 g of water.\n\n**Given:** Mass = 18 g, Molar mass of $H_2O = 18$ g/mol\n\n**Solution:**\n\n$$\n\\text{Moles} = \\frac{\\text{Mass}}{\\text{Molar Mass}} = \\frac{18}{18} = 1 \\text{ mol}\n$$\n\n$$\n\\text{Molecules} = n \\times N_A = 1 \\times 6.022 \\times 10^{23} = 6.022 \\times 10^{23}\n$$\n\n**Answer:** $6.022 \\times 10^{23}$ molecules\n:::\n',
    },
    {
      label: 'Titration', title: 'Titration Calculation',
      insert: '\n:::solved\n**Problem:** 25 mL of NaOH is titrated against 0.1 M HCl. If 20 mL HCl is needed, find molarity of NaOH.\n\n**At equivalence point:**\n$$\nM_1 V_1 = M_2 V_2\n$$\n\n$$\n0.1 \\times 20 = M_2 \\times 25\n$$\n\n$$\nM_2 = \\frac{2}{25} = 0.08 \\text{ M}\n$$\n\n**Answer:** Molarity of NaOH = **0.08 M**\n:::\n',
    },
    {
      label: 'Equilibrium', title: 'Chemical Equilibrium Block',
      insert: '\n:::formula\n**Equilibrium:** $aA + bB \\rightleftharpoons cC + dD$\n\n$$\nK_c = \\frac{[C]^c[D]^d}{[A]^a[B]^b}\n$$\n\n$$\nK_p = K_c(RT)^{\\Delta n}\n$$\n\n**Le Chatelier\'s Principle:** If a system at equilibrium is disturbed, it shifts in the direction that opposes the disturbance.\n\n| Change | Shift |\n|--------|-------|\n| ↑ Concentration of reactant | → Forward |\n| ↑ Temperature (exothermic) | → Reverse |\n| ↑ Pressure | → Side with fewer moles of gas |\n:::\n',
    },
    {
      label: 'Electrochemistry', title: 'Electrochemistry Cell',
      insert: '\n:::formula\n**Galvanic Cell:** $\\text{Zn} | \\text{Zn}^{2+} || \\text{Cu}^{2+} | \\text{Cu}$\n\n**Anode (oxidation):** $\\text{Zn} \\rightarrow \\text{Zn}^{2+} + 2e^-$ ; $E° = +0.76$ V\n\n**Cathode (reduction):** $\\text{Cu}^{2+} + 2e^- \\rightarrow \\text{Cu}$ ; $E° = +0.34$ V\n\n$$\nE°_{\\text{cell}} = E°_{\\text{cathode}} - E°_{\\text{anode}} = 0.34 - (-0.76) = 1.10 \\text{ V}\n$$\n\n**Nernst Equation:**\n$$\nE = E° - \\frac{0.0592}{n} \\log Q\n$$\n:::\n',
    },
    {
      label: 'Thermodynamics', title: 'Thermodynamics Block',
      insert: '\n:::formula\n**Gibbs Free Energy:**\n$$\n\\Delta G = \\Delta H - T\\Delta S\n$$\n\n| $\\Delta H$ | $\\Delta S$ | $\\Delta G$ | Spontaneous? |\n|-----------|-----------|-----------|-------------|\n| − | + | Always − | Always ✓ |\n| + | − | Always + | Never ✗ |\n| − | − | Depends on $T$ | At low $T$ |\n| + | + | Depends on $T$ | At high $T$ |\n:::\n',
    },
    {
      label: 'Rate Law', title: 'Reaction Rate Law',
      insert: '\n:::formula\n**Rate Law:** $\\text{Rate} = k[A]^m[B]^n$\n\n- $k$ = rate constant\n- $m, n$ = order w.r.t. A and B\n- Overall order = $m + n$\n\n**Integrated Rate Laws:**\n\n| Order | Integrated Form | Half-life $t_{1/2}$ |\n|-------|----------------|-------------------|\n| 0 | $[A] = [A]_0 - kt$ | $\\dfrac{[A]_0}{2k}$ |\n| 1 | $\\ln[A] = \\ln[A]_0 - kt$ | $\\dfrac{0.693}{k}$ |\n| 2 | $\\dfrac{1}{[A]} = \\dfrac{1}{[A]_0} + kt$ | $\\dfrac{1}{k[A]_0}$ |\n:::\n',
    },
    {
      label: 'Lab Procedure', title: 'Lab Procedure Block',
      insert: '\n:::experiment\n**Experiment:** Name of experiment\n\n**Aim:** To determine / To observe...\n\n**Materials Required:**\n- Apparatus 1\n- Chemical 1\n\n**Procedure:**\n1. Step one\n2. Step two\n3. Step three\n\n**Observations:**\n| Trial | Reading | Observation |\n|-------|---------|-------------|\n| 1 | - | - |\n\n**Result:** \n\n**Precautions:**\n- Precaution 1\n- Precaution 2\n:::\n',
    },
    {
      label: 'Safety Warning', title: 'Lab Safety Warning',
      insert: '\n:::warning\n**⚠️ Safety Precaution**\n\n- **Hazard:** Corrosive / Flammable / Toxic\n- **Chemical:** Name of substance\n- **Precaution:** Always wear gloves and safety goggles. Work in a fume hood.\n- **In case of contact:** Rinse immediately with large amounts of water.\n:::\n',
    },
    {
      label: 'Property Table', title: 'Chemical Properties Table',
      insert: '\n| Property | Metal | Non-Metal |\n|----------|-------|----------|\n| Physical state (at RT) | Solid (except Hg) | Solid/Liquid/Gas |\n| Lustre | Shiny | Dull |\n| Conductivity | Good | Poor (except graphite) |\n| Malleability | Malleable | Brittle |\n| Oxide nature | Basic | Acidic |\n| Electronegativity | Low | High |\n',
    },
    {
      label: 'MCQ (Chem)', title: 'Chemistry MCQ',
      insert: '\n:::mcq\n**Q.** Which of the following is the correct IUPAC name of $CH_3-CH(OH)-CH_3$?\n\n(A) 1-methylethanol\n\n(B) propan-2-ol\n\n(C) isopropyl alcohol\n\n(D) 2-propanol\n\n:::remember\n**Answer:** (B) propan-2-ol\n\n*The longest chain has 3 carbons (propane), —OH on C2 → propan-2-ol*\n:::\n:::\n',
    },
    {
      label: 'Assertion-Reason', title: 'Assertion-Reason (Chemistry)',
      insert: '\n:::important\n**Assertion (A):** Noble gases have very low chemical reactivity.\n\n**Reason (R):** Noble gases have completely filled outermost orbitals.\n\n---\n\n*(A) Both A and R are true, and R is the correct explanation of A.*\n\n(B) Both A and R are true, but R is not the correct explanation of A.\n\n(C) A is true but R is false.\n\n(D) A is false but R is true.\n\n:::remember\n**Answer:** (A)\n:::\n:::\n',
    },
  ],
};

// ── PHYSICS GROUP ─────────────────────────────────────────────────────────────
export const GROUP_PHYSICS = {
  key: 'physics', label: 'Physics', icon: IC.physics,
  items: [
    {
      label: 'Law Block', title: 'Laws of Physics Block',
      insert: '\n:::law\n**Newton\'s Second Law of Motion**\n\n*Statement:* The rate of change of momentum of a body is directly proportional to the applied force and takes place in the direction in which the force acts.\n\n$$\n\\vec{F} = m\\vec{a} = \\frac{d\\vec{p}}{dt}\n$$\n\n**SI Unit:** Newton (N) = kg⋅m/s²\n\n**Important:** This is a vector equation.\n:::\n',
    },
    {
      label: 'Derivation', title: 'Physics Derivation Block',
      insert: '\n:::derivation\n**Derive:** Expression for Escape Velocity\n\n**Concept:** KE provided = PE to be overcome\n\n$$\n\\frac{1}{2}mv_e^2 = \\frac{GMm}{R}\n$$\n\n$$\nv_e = \\sqrt{\\frac{2GM}{R}} = \\sqrt{2gR}\n$$\n\nSubstituting $g = 9.8$ m/s², $R = 6.4 \\times 10^6$ m:\n\n$$\n\\boxed{v_e \\approx 11.2 \\text{ km/s}}\n$$\n:::\n',
    },
    {
      label: 'Dimensional', title: 'Dimensional Analysis',
      insert: '\n:::steps\n**Check dimensions of:** Kinetic Energy $KE = \\frac{1}{2}mv^2$\n\n$$\n[KE] = [M][LT^{-1}]^2 = [ML^2T^{-2}]\n$$\n\n**SI unit:** kg⋅m²/s² = Joule (J) ✓\n\n**Principle:** Dimensions on both sides of an equation must be equal.\n:::\n',
    },
    {
      label: 'Kinematics', title: 'Kinematics Worked Example',
      insert: '\n:::solved\n**Problem:** A car starts from rest and accelerates at 4 m/s². Find velocity and distance after 5 s.\n\n**Given:** $u = 0$, $a = 4$ m/s², $t = 5$ s\n\n**SUVAT Equations:**\n$$\nv = u + at = 0 + 4 \\times 5 = 20 \\text{ m/s}\n$$\n\n$$\ns = ut + \\frac{1}{2}at^2 = 0 + \\frac{1}{2}(4)(25) = 50 \\text{ m}\n$$\n\n**Answer:** $v = 20$ m/s, $s = 50$ m\n:::\n',
    },
    {
      label: 'Wave Equation', title: 'Wave Equation Block',
      insert: '\n:::formula\n**Progressive Wave Equation:**\n$$\ny(x,t) = A\\sin(\\omega t - kx + \\phi)\n$$\n\n**Where:**\n- $A$ = Amplitude (m)\n- $\\omega = 2\\pi f$ = Angular frequency (rad/s)\n- $k = \\dfrac{2\\pi}{\\lambda}$ = Wave number (rad/m)\n- $v = \\dfrac{\\omega}{k} = f\\lambda$ = Wave speed\n:::\n',
    },
    {
      label: 'SHM', title: 'Simple Harmonic Motion',
      insert: '\n:::formula\n**SHM Equation:**\n$$\n\\frac{d^2x}{dt^2} + \\omega^2 x = 0 \\implies x = A\\cos(\\omega t + \\phi)\n$$\n\n| Quantity | Expression |\n|---------|------------|\n| Displacement | $x = A\\cos\\omega t$ |\n| Velocity | $v = -A\\omega\\sin\\omega t = \\omega\\sqrt{A^2-x^2}$ |\n| Acceleration | $a = -\\omega^2 x$ |\n| Time period | $T = \\dfrac{2\\pi}{\\omega}$ |\n| Total Energy | $E = \\dfrac{1}{2}m\\omega^2A^2$ = constant |\n:::\n',
    },
    {
      label: 'Optics', title: 'Optics – Mirror/Lens Formula',
      insert: '\n:::formula\n**Mirror Formula:**\n$$\n\\frac{1}{f} = \\frac{1}{v} + \\frac{1}{u}\n$$\n\n**Lens Formula:**\n$$\n\\frac{1}{f} = \\frac{1}{v} - \\frac{1}{u}\n$$\n\n**Magnification:** $m = -\\dfrac{v}{u}$ (mirror), $m = \\dfrac{v}{u}$ (lens)\n\n**Sign Convention:** All distances from pole/optical centre; distances in direction of incident ray = positive.\n:::\n',
    },
    {
      label: 'Modern Physics', title: 'Modern Physics Block',
      insert: '\n:::formula\n**Photoelectric Effect (Einstein):**\n$$\nKE_{\\max} = h\\nu - \\phi = h(\\nu - \\nu_0)\n$$\n\n**de Broglie Wavelength:**\n$$\n\\lambda = \\frac{h}{mv} = \\frac{h}{p}\n$$\n\n**Bohr\'s Model (H-atom):**\n$$\nE_n = -\\frac{13.6}{n^2} \\text{ eV},\\quad r_n = 0.529 n^2 \\text{ Å}\n$$\n:::\n',
    },
    {
      label: 'Electricity', title: 'Electricity – Kirchhoff\'s Laws',
      insert: '\n:::formula\n**Kirchhoff\'s Laws**\n\n**KCL (Junction Rule):** $\\sum I_{\\text{in}} = \\sum I_{\\text{out}}$\n\n**KVL (Loop Rule):** $\\sum V = 0$ around any closed loop\n\n**Ohm\'s Law:** $V = IR$\n\n**Power:** $P = VI = I^2R = \\dfrac{V^2}{R}$\n\n**Resistors in Series:** $R_{eq} = R_1 + R_2 + R_3$\n\n**Resistors in Parallel:** $\\dfrac{1}{R_{eq}} = \\dfrac{1}{R_1} + \\dfrac{1}{R_2} + \\dfrac{1}{R_3}$\n:::\n',
    },
    {
      label: 'Magnetism', title: 'Magnetism Formulas',
      insert: '\n:::formula\n**Biot-Savart Law:**\n$$\nd\\vec{B} = \\frac{\\mu_0}{4\\pi} \\frac{I\\,d\\vec{l} \\times \\hat{r}}{r^2}\n$$\n\n**Ampere\'s Law:**\n$$\n\\oint \\vec{B} \\cdot d\\vec{l} = \\mu_0 I_{\\text{enc}}\n$$\n\n**Lorentz Force:** $\\vec{F} = q(\\vec{E} + \\vec{v} \\times \\vec{B})$\n:::\n',
    },
    {
      label: 'Numerical', title: 'Physics Numerical Problem',
      insert: '\n:::solved\n**Problem:** State problem here.\n\n**Given:**\n- Quantity 1: value with unit\n- Quantity 2: value with unit\n\n**To Find:** Required quantity\n\n**Formula:**\n$$\n\\text{Relevant formula here}\n$$\n\n**Solution:**\n\nStep 1: Substitute values\n\n$$\n\\text{Working shown here}\n$$\n\n**Answer:** Final answer with proper unit\n:::\n',
    },
    {
      label: 'Unit Conversion', title: 'Unit Conversion Block',
      insert: '\n:::steps\n**Convert:** 60 km/h to m/s\n\n$$\n60 \\text{ km/h} = 60 \\times \\frac{1000 \\text{ m}}{3600 \\text{ s}} = \\frac{60000}{3600} = \\frac{50}{3} \\approx 16.67 \\text{ m/s}\n$$\n\n**Quick rule:** Divide km/h by 3.6 to get m/s\n:::\n',
    },
    {
      label: 'Experiment', title: 'Physics Experiment Block',
      insert: '\n:::experiment\n**Experiment:** Verification of Ohm\'s Law\n\n**Aim:** To verify that $V \\propto I$ for a metallic conductor at constant temperature.\n\n**Apparatus:** Resistor, ammeter, voltmeter, battery, rheostat, key\n\n**Procedure:**\n1. Connect circuit as per diagram\n2. Vary rheostat, note V and I readings\n3. Plot V-I graph\n\n**Observations:**\n| V (volts) | I (amperes) | V/I (Ω) |\n|-----------|-------------|----------|\n| 1.0 | 0.1 | 10 |\n| 2.0 | 0.2 | 10 |\n\n**Result:** V/I = constant = R. Ohm\'s Law verified.\n:::\n',
    },
    {
      label: 'MCQ (Physics)', title: 'Physics MCQ',
      insert: '\n:::mcq\n**Q.** A body of mass 2 kg moves with velocity 3 m/s. Its kinetic energy is:\n\n(A) 3 J\n\n(B) 6 J\n\n(C) 9 J\n\n(D) 12 J\n\n:::remember\n**Answer:** (C) 9 J\n\n$KE = \\dfrac{1}{2}mv^2 = \\dfrac{1}{2}(2)(3)^2 = 9$ J\n:::\n:::\n',
    },
    {
      label: 'Integer Type', title: 'JEE Integer Type Question',
      insert: '\n:::mcq\n**Q. [Integer Type]** A particle moves along x-axis. Its position is $x = 3t^2 - 2t + 1$. Find the acceleration (in m/s²) at $t = 2$ s.\n\n*Write your answer as a single integer.*\n\n:::remember\n**Answer:** 6\n\n$v = \\dfrac{dx}{dt} = 6t - 2$, $a = \\dfrac{dv}{dt} = 6$ m/s² (constant)\n:::\n:::\n',
    },
    {
      label: 'Graph Interpretation', title: 'Graph Interpretation Block',
      insert: '\n:::definition\n**Graph:** Velocity-Time Graph Analysis\n\n**What the slope represents:** Acceleration ($a = \\Delta v / \\Delta t$)\n\n**What the area represents:** Displacement\n\n**Key points to note:**\n- Horizontal line → constant velocity (zero acceleration)\n- Rising line → positive acceleration\n- Falling line → deceleration (negative acceleration)\n- Area below x-axis → displacement in negative direction\n:::\n',
    },
    {
      label: 'Assertion-Reason', title: 'Assertion-Reason (Physics)',
      insert: '\n:::important\n**Assertion (A):** Work done by friction is always negative.\n\n**Reason (R):** Friction always acts opposite to the direction of motion.\n\n---\n\n(A) Both A and R are true, and R is the correct explanation of A.\n\n*(B) Both A and R are true, but R is not the correct explanation of A.*\n\n(C) A is true but R is false.\n\n(D) A is false but R is true.\n\n:::remember\n**Answer:** (B) — Friction can do positive work (e.g., on a book kept on an accelerating truck).\n:::\n:::\n',
    },
  ],
};

// ── BIOLOGY GROUP ─────────────────────────────────────────────────────────────
export const GROUP_BIOLOGY = {
  key: 'biology', label: 'Biology', icon: IC.biology,
  items: [
    {
      label: 'Classification', title: 'Organism Classification',
      insert: '\n:::organism\n**Classification of:** Name of organism\n\n| Taxon | Name |\n|-------|------|\n| Kingdom | Animalia / Plantae |\n| Phylum / Division | — |\n| Class | — |\n| Order | — |\n| Family | — |\n| Genus | — |\n| Species | — |\n\n**Common name:** ___\n**Scientific name:** *Genus species*\n:::\n',
    },
    {
      label: 'Process Flow', title: 'Biological Process Flow',
      insert: '\n:::steps\n**Process:** Photosynthesis\n\n**Overall Equation:**\n$$\n6CO_2 + 6H_2O \\xrightarrow{\\text{Light}} C_6H_{12}O_6 + 6O_2\n$$\n\n**Step 1 — Light Reactions (Thylakoid):**\n- Light absorbed by chlorophyll\n- Water split (photolysis): $2H_2O \\rightarrow 4H^+ + 4e^- + O_2$\n- ATP and NADPH produced\n\n**Step 2 — Dark Reactions / Calvin Cycle (Stroma):**\n- $CO_2$ fixed using RuBisCO\n- G3P produced → Glucose\n- ATP and NADPH consumed\n:::\n',
    },
    {
      label: 'Life Cycle (Bio)', title: 'Life Cycle Block',
      insert: '\n:::lifecycle\ntitle=Life Cycle of a Frog (Amphibian)\ncircular=true\n1. Egg | 🥚\n2. Tadpole | 🐟\n3. Tadpole with legs | 🐸\n4. Froglet | 🐸\n5. Adult Frog | 🐸\n:::\n',
    },
    {
      label: 'Comparison Table', title: 'Biology Comparison Table',
      insert: '\n| Feature | Mitosis | Meiosis |\n|---------|---------|----------|\n| Purpose | Growth / repair | Sexual reproduction |\n| Divisions | 1 | 2 |\n| Daughter cells | 2 | 4 |\n| Ploidy | 2n → 2n | 2n → n |\n| Crossing over | No | Yes |\n| Occurs in | Somatic cells | Reproductive cells |\n',
    },
    {
      label: 'Genetics Problem', title: 'Genetics / Punnett Square',
      insert: '\n:::solved\n**Problem:** Cross between Tt (tall) × Tt (tall) plants. Find phenotypic ratio.\n\n**Punnett Square:**\n\n| | **T** | **t** |\n|---|---|---|\n| **T** | TT | Tt |\n| **t** | Tt | tt |\n\n**Genotypic ratio:** 1 TT : 2 Tt : 1 tt\n\n**Phenotypic ratio:** 3 Tall : 1 Short (3:1)\n\n**Law applied:** Mendel\'s Law of Segregation\n:::\n',
    },
    {
      label: 'Disease Note', title: 'Disease Information Block',
      insert: '\n:::important\n**Disease:** Name of disease\n\n| Aspect | Details |\n|--------|----------|\n| Causative agent | Bacteria / Virus / Fungus / Parasite |\n| Mode of transmission | Air / Water / Contact / Vector |\n| Symptoms | Fever, ... |\n| Incubation period | X days |\n| Treatment | Drug / Vaccine |\n| Prevention | Hygiene / Vaccination |\n:::\n',
    },
    {
      label: 'Diagram Labels', title: 'Diagram Label Block',
      insert: '\n:::definition\n**Diagram:** Name of structure/organ\n\n![Diagram](https://via.placeholder.com/600x350?text=Insert+Diagram+Here)\n\n**Labels:**\n1. Part A — Function/description\n2. Part B — Function/description\n3. Part C — Function/description\n4. Part D — Function/description\n\n*Replace placeholder with actual diagram image*\n:::\n',
    },
    {
      label: 'Hormone Table', title: 'Hormone Reference Table',
      insert: '\n| Gland | Hormone | Target | Function |\n|-------|---------|--------|----------|\n| Pituitary (anterior) | GH | Bones/muscles | Growth |\n| Thyroid | Thyroxine | Metabolism | Controls BMR |\n| Adrenal cortex | Cortisol | Whole body | Stress response |\n| Pancreas (β cells) | Insulin | Liver/muscle | Lowers blood sugar |\n| Pancreas (α cells) | Glucagon | Liver | Raises blood sugar |\n| Gonads (testes) | Testosterone | Reproductive | Male characteristics |\n| Gonads (ovaries) | Estrogen | Reproductive | Female characteristics |\n',
    },
    {
      label: 'Ecology Block', title: 'Ecology / Food Chain',
      insert: '\n:::definition\n**Food Chain:**\n\n```\nProducers → Primary Consumers → Secondary Consumers → Tertiary Consumers\n(Plants)     (Grasshoppers)     (Frogs)               (Snakes → Eagle)\n```\n\n**Energy flow:** ~10% transferred at each trophic level (10% Law)\n\n**Food Web:** Multiple interconnected food chains in an ecosystem.\n\n**Ecological Pyramid:**\n- **Energy pyramid:** Always upright\n- **Biomass pyramid:** Usually upright\n- **Number pyramid:** Can be inverted (e.g. tree → insects)\n:::\n',
    },
    {
      label: 'MCQ (Biology)', title: 'NEET-Style Biology MCQ',
      insert: '\n:::mcq\n**Q.** Which of the following is NOT a component of the cell membrane?\n\n(A) Phospholipid bilayer\n\n(B) Integral proteins\n\n(C) Cellulose\n\n(D) Cholesterol\n\n:::remember\n**Answer:** (C) Cellulose\n\n*Cellulose is a component of the cell wall (in plants), NOT the cell membrane.*\n:::\n:::\n',
    },
    {
      label: 'Experiment (Bio)', title: 'Biology Experiment',
      insert: '\n:::experiment\n**Experiment:** To observe osmosis using potato strips\n\n**Aim:** To demonstrate the process of osmosis\n\n**Materials:** Potato, distilled water, salt solution, petri dishes, ruler\n\n**Procedure:**\n1. Cut uniform potato strips (~5 cm each)\n2. Weigh each strip (initial weight)\n3. Place strips in: (a) distilled water (b) concentrated salt solution (c) air\n4. After 30 min, remove and weigh (final weight)\n\n**Expected Observations:**\n- Strip in distilled water: becomes turgid (gains mass)\n- Strip in salt solution: becomes flaccid (loses mass)\n\n**Conclusion:** Water moves from high water potential (dilute) to low water potential (concentrated).\n:::\n',
    },
  ],
};

// ── GENERAL ACADEMICS GROUP ───────────────────────────────────────────────────
export const GROUP_GENERAL = {
  key: 'general', label: 'General', icon: IC.general,
  items: [
    {
      label: 'Chapter Summary', title: 'Chapter Summary Block',
      insert: '\n:::summary\n## 📋 Chapter Summary\n\n**Chapter:** Chapter name\n\n**Key Topics Covered:**\n- Topic 1: Brief description\n- Topic 2: Brief description\n- Topic 3: Brief description\n\n**Key Formulas:**\n$$\n\\text{Important formula here}\n$$\n\n**Important Terms:** Term 1, Term 2, Term 3\n\n**Points to Remember:**\n1. Point one\n2. Point two\n:::\n',
    },
    {
      label: 'Objectives', title: 'Learning Objectives',
      insert: '\n:::objectives\n## 🎯 Learning Objectives\n\nBy the end of this topic, you will be able to:\n\n- [ ] Objective 1\n- [ ] Objective 2\n- [ ] Objective 3\n- [ ] Objective 4\n\n**Prerequisites:** What you should already know before this topic.\n:::\n',
    },
    {
      label: 'Vocabulary', title: 'Vocabulary Table',
      insert: '\n:::vocab\n## 📚 Key Terms\n\n| Term | Definition | Example |\n|------|------------|----------|\n| Term 1 | Clear, simple definition | Example usage |\n| Term 2 | Clear, simple definition | Example usage |\n| Term 3 | Clear, simple definition | Example usage |\n:::\n',
    },
    {
      label: 'Did You Know', title: 'Did You Know Block',
      insert: '\n:::didyouknow\n**🤔 Did You Know?**\n\nInteresting fact related to the topic here. Keep it concise, surprising, and relevant to motivate students.\n:::\n',
    },
    {
      label: 'Real World', title: 'Real World Application',
      insert: '\n:::realworld\n**🌍 Real World Application**\n\n**Concept:** Name of concept\n\n**Where it is used:**\n- Application 1: Brief description\n- Application 2: Brief description\n- Application 3: Brief description\n\n**Why it matters:** One sentence on the significance.\n:::\n',
    },
    {
      label: 'Analogy', title: 'Analogy / Explanation Block',
      insert: '\n:::analogy\n**💭 Think of it this way...**\n\n**Concept:** Name of difficult concept\n\n**Analogy:** Compare to a familiar everyday thing\n\nJust like **[familiar thing]**, **[concept]** works by...\n\nThis helps us understand why [key insight].\n:::\n',
    },
    {
      label: 'Misconception', title: 'Common Misconception Block',
      insert: '\n:::misconception\n**🚫 Common Misconception**\n\n| ❌ Wrong Thinking | ✅ Correct Understanding |\n|-----------------|-------------------------|\n| Misconception 1 | Correct explanation 1 |\n| Misconception 2 | Correct explanation 2 |\n| Misconception 3 | Correct explanation 3 |\n:::\n',
    },
    {
      label: 'Mind Map', title: 'Mind Map Outline',
      insert: '\n:::definition\n**🧠 Mind Map: Topic Name**\n\n```\n                    [MAIN TOPIC]\n                         |\n          ┌──────────────┼──────────────┐\n          │              │              │\n    [Branch 1]     [Branch 2]     [Branch 3]\n       │               │               │\n  [Sub 1.1]       [Sub 2.1]       [Sub 3.1]\n  [Sub 1.2]       [Sub 2.2]       [Sub 3.2]\n```\n:::\n',
    },
    {
      label: 'Quick Revision', title: 'Quick Revision Block',
      insert: '\n:::remember\n## ⚡ Quick Revision\n\n**Topic:** Topic name\n\n- 📌 Point 1: Key fact\n- 📌 Point 2: Key fact\n- 📌 Point 3: Key formula or concept\n- 📌 Point 4: Important exception\n- 📌 Point 5: Exam tip\n:::\n',
    },
    {
      label: 'Fill in Blank', title: 'Fill in the Blank Exercise',
      insert: '\n:::mcq\n**Fill in the Blanks:**\n\n1. The process by which plants make food is called ________.\n2. The SI unit of force is ________.\n3. The chemical symbol for Gold is ________.\n4. ________ is known as the powerhouse of the cell.\n5. The speed of light is approximately ________ m/s.\n\n:::remember\n**Answers:**\n1. Photosynthesis\n2. Newton (N)\n3. Au\n4. Mitochondria\n5. $3 \\times 10^8$\n:::\n:::\n',
    },
    {
      label: 'Match Following', title: 'Match the Following',
      insert: '\n:::mcq\n**Match the Following:**\n\n| Column A | Column B |\n|----------|----------|\n| 1. Nucleus | (a) Protein synthesis |\n| 2. Ribosome | (b) Energy production |\n| 3. Mitochondria | (c) Control centre |\n| 4. Chloroplast | (d) Photosynthesis |\n\n:::remember\n**Answers:** 1-c, 2-a, 3-b, 4-d\n:::\n:::\n',
    },
    {
      label: 'True/False', title: 'True / False Exercise',
      insert: '\n:::mcq\n**True or False:**\n\n1. The earth revolves around the sun. _____\n2. Water is a compound. _____\n3. Sound travels faster than light. _____\n4. DNA stands for Deoxyribose Nucleic Acid. _____\n\n:::remember\n**Answers:**\n1. True\n2. True\n3. False (Light is faster)\n4. True\n:::\n:::\n',
    },
    {
      label: 'Historical Context', title: 'Historical Context Block',
      insert: '\n:::definition\n**📜 Historical Context**\n\n**Period/Year:** When did this happen?\n\n**Background:** Brief historical context\n\n**Key Figure:** Scientist/Historian/Person name and contribution\n\n**Timeline:**\n- Year 1: Event\n- Year 2: Discovery\n- Year 3: Impact/Application\n\n**Significance:** Why this matters today.\n:::\n',
    },
    {
      label: 'Interview Q&A', title: 'Interview / Viva Q&A Block',
      insert: '\n:::important\n**📝 Important Q&A (Viva/Interview)**\n\n**Q1:** Question here?\n\n**A:** Model answer here (2-3 sentences, precise and complete).\n\n---\n\n**Q2:** Question here?\n\n**A:** Model answer here.\n\n---\n\n**Q3:** Question here?\n\n**A:** Model answer here.\n:::\n',
    },
  ],
};

// ── EXAM GROUP ────────────────────────────────────────────────────────────────
export const GROUP_EXAM = {
  key: 'exam', label: 'Exam Prep', icon: IC.exam,
  items: [
    {
      label: 'PYQ', title: 'Previous Year Question',
      insert: '\n:::pyq\n**📝 Previous Year Question**\n\n**Year:** XXXX | **Exam:** JEE Main / NEET / CBSE Board | **Marks:** X\n\n**Q.** Write the previous year question here.\n\n---\n\n**Solution:**\n\nStep by step solution here.\n\n$$\n\\text{Key formula / answer}\n$$\n\n**Answer:** Final answer\n:::\n',
    },
    {
      label: 'Case Study', title: 'CBSE Case Study Block',
      insert: '\n:::casestudy\n**📂 Case Study**\n\n**Read the following and answer the questions:**\n\nPassage text here. This is the reading comprehension / stimulus material that students must read before answering the questions below.\n\n---\n\n**Q1.** Question based on the passage?\n\n(A) Option A (B) Option B (C) Option C (D) Option D\n\n**Q2.** Another question?\n\n(A) Option A (B) Option B (C) Option C (D) Option D\n\n:::remember\n**Answers:** Q1-(A), Q2-(B)\n:::\n:::\n',
    },
    {
      label: '5-Mark Answer', title: '5-Mark Board Answer Format',
      insert: '\n:::steps\n**Q. [5 Marks]** Write the question here.\n\n**Answer:**\n\n**Introduction (1 mark):** Brief intro sentence.\n\n**Main Content (3 marks):**\n\n**Point 1:** Explanation\n\n**Point 2:** Explanation\n\n**Point 3:** With diagram/formula if applicable\n\n$$\n\\text{Formula if needed}\n$$\n\n**Conclusion (1 mark):** Summarise in 1-2 lines.\n:::\n',
    },
    {
      label: '1-Mark Answer', title: '1-Mark Short Answer',
      insert: '\n:::tip\n**Q.** Short question here?\n\n**A:** One sentence, precise answer. Include unit/formula if applicable.\n:::\n',
    },
    {
      label: 'Passage MCQ', title: 'Passage-Based MCQ',
      insert: '\n:::casestudy\n**Passage:**\n\nRead the following passage carefully:\n\n*[Paste or write the stimulus passage here — 80-100 words]*\n\n---\n\n**Based on the passage, answer the following:**\n\n**Q1.** Question 1?\n(A) Option  (B) Option  (C) Option  (D) Option\n\n**Q2.** Question 2?\n(A) Option  (B) Option  (C) Option  (D) Option\n\n**Q3.** Question 3?\n(A) Option  (B) Option  (C) Option  (D) Option\n\n:::remember\n**Answers:** Q1-(A), Q2-(C), Q3-(B)\n:::\n:::\n',
    },
    {
      label: 'Revision Checklist', title: 'Revision Checklist',
      insert: '\n:::objectives\n## ✅ Revision Checklist — Topic Name\n\n**Before exam, make sure you can:**\n\n- [ ] Define key terms\n- [ ] State all laws/principles\n- [ ] Derive important formulas\n- [ ] Solve numerical problems\n- [ ] Draw and label diagrams\n- [ ] Explain real-world applications\n- [ ] Attempt PYQ questions\n:::\n',
    },
    {
      label: 'Marks Distribution', title: 'Marks Distribution Table',
      insert: '\n| Chapter | Weightage (Marks) | Important Topics |\n|---------|------------------|------------------|\n| Chapter 1 | 5 | Topic A, Topic B |\n| Chapter 2 | 8 | Topic C, Topic D |\n| Chapter 3 | 10 | Topic E, Topic F |\n| **Total** | **23** | |\n',
    },
    {
      label: 'Difficulty Tag', title: 'Difficulty Level Tag',
      insert: '\n:::tip\n**Difficulty:** 🟢 Easy / 🟡 Medium / 🔴 Hard\n\n**Topic Weightage:** High / Medium / Low\n\n**Expected Time:** X minutes\n:::\n',
    },
    {
      label: 'Mistake Log', title: 'Mistake Log Table',
      insert: '\n:::misconception\n## ❌ My Mistake Log\n\n| Question | My Wrong Answer | Correct Answer | Why I Was Wrong | Revision Date |\n|----------|----------------|----------------|-----------------|---------------|\n| Q1 | - | - | Concept gap | - |\n| Q2 | - | - | Calculation error | - |\n| Q3 | - | - | Formula confusion | - |\n:::\n',
    },
    {
      label: 'Study Plan', title: '30-Day Study Plan',
      insert: '\n| Week | Days | Topics | Target |\n|------|------|--------|--------|\n| Week 1 | Day 1-3 | Chapter 1-2 | Concept clarity |\n| Week 1 | Day 4-5 | Chapter 3 | Practice numericals |\n| Week 2 | Day 6-10 | Chapter 4-6 | Formulas + MCQs |\n| Week 3 | Day 11-20 | Chapter 7-12 | Full revision |\n| Week 4 | Day 21-28 | PYQs + Mock | Exam simulation |\n| Week 5 | Day 29-30 | Weak areas | Final brush-up |\n',
    },
    {
      label: 'Value Based Q', title: 'Value Based Question (CBSE)',
      insert: '\n:::casestudy\n**Q. [Value Based]** Write the value-based question here.\n\n**Answer:**\n\n**Values Exhibited:** Honesty / Empathy / Environmental consciousness / Scientific temper\n\n**Explanation:** How the values relate to the concept being studied.\n\n**Scientific Connection:** Brief explanation of the scientific concept.\n:::\n',
    },
    {
      label: 'Exam Day Tips', title: 'Exam Day Tips Callout',
      insert: '\n:::tip\n## 🎯 Exam Day Tips\n\n- ⏱️ **Time Management:** Allocate ~1 min per mark. Don\'t get stuck.\n- ✏️ **Attempt order:** Easy → Medium → Hard\n- 📝 **Show work:** Partial marks available for correct steps\n- 🔢 **Units:** Always include units in numerical answers\n- 📐 **Diagrams:** Label clearly; a good diagram = marks\n- ✅ **Review:** Save 10 mins at end to check answers\n:::\n',
    },
    {
      label: 'Source Based', title: 'Source Based Question (History/Eco)',
      insert: '\n:::casestudy\n**Source:** Title of source / Document name\n\n*"Quote or passage from the historical/economic source here. This should be 3-5 sentences that students need to analyse."*\n\n— *Author/Origin, Year*\n\n---\n\n**Q1.** Identify the context of this source. (1 mark)\n\n**Q2.** What does this source tell us about [topic]? (2 marks)\n\n**Q3.** How does this source connect to [broader theme]? (3 marks)\n:::\n',
    },
  ],
};

// ── COMPUTER SCIENCE GROUP ────────────────────────────────────────────────────
export const GROUP_CS = {
  key: 'cs', label: 'Computer Science', icon: IC.computer,
  items: [
    {
      label: 'Algorithm', title: 'Algorithm Pseudocode Block',
      insert: '\n:::algorithm\n**Algorithm:** Bubble Sort\n\n**Input:** Array A of n elements\n**Output:** Sorted array A\n\n```\nPROCEDURE BubbleSort(A, n)\n  FOR i = 0 TO n-2\n    FOR j = 0 TO n-2-i\n      IF A[j] > A[j+1] THEN\n        SWAP A[j] AND A[j+1]\n      END IF\n    END FOR\n  END FOR\nEND PROCEDURE\n```\n\n**Time Complexity:** O(n²) | **Space Complexity:** O(1)\n:::\n',
    },
    {
      label: 'Complexity Table', title: 'Time Complexity Comparison',
      insert: '\n| Algorithm | Best | Average | Worst | Space |\n|-----------|------|---------|-------|-------|\n| Bubble Sort | O(n) | O(n²) | O(n²) | O(1) |\n| Merge Sort | O(n log n) | O(n log n) | O(n log n) | O(n) |\n| Quick Sort | O(n log n) | O(n log n) | O(n²) | O(log n) |\n| Binary Search | O(1) | O(log n) | O(log n) | O(1) |\n| Linear Search | O(1) | O(n) | O(n) | O(1) |\n',
    },
    {
      label: 'Code Explanation', title: 'Code with Explanation',
      insert: '\n```python\ndef fibonacci(n):\n    if n <= 1:          # Base case\n        return n\n    return fibonacci(n-1) + fibonacci(n-2)  # Recursive call\n```\n\n:::definition\n**Line-by-line Explanation:**\n- **Line 1:** Function definition, takes integer `n`\n- **Line 2-3:** Base case — if n is 0 or 1, return n itself\n- **Line 4:** Recursive case — sum of two preceding Fibonacci numbers\n\n**Time Complexity:** O(2ⁿ) | **Space Complexity:** O(n)\n:::\n',
    },
    {
      label: 'Flowchart', title: 'Algorithm Flowchart (Text)',
      insert: '\n:::definition\n**Flowchart:** Find maximum of two numbers\n\n```\n       ┌──────────┐\n       │  START   │\n       └────┬─────┘\n            │\n       ┌────▼─────┐\n       │ Input A,B│\n       └────┬─────┘\n            │\n       ┌────▼──────────┐\n       │  Is A > B?    │\n       └────┬──────┬───┘\n         YES│      │NO\n       ┌────▼──┐ ┌─▼────────┐\n       │Print A│ │ Print B  │\n       └────┬──┘ └─┬────────┘\n            └──────┘\n                │\n          ┌─────▼──────┐\n          │    END     │\n          └────────────┘\n```\n:::\n',
    },
    {
      label: 'DB Schema', title: 'Database Schema Note',
      insert: '\n:::definition\n**Table:** `students`\n\n| Column | Type | Constraints |\n|--------|------|-------------|\n| `id` | INT | PRIMARY KEY, AUTO_INCREMENT |\n| `name` | VARCHAR(100) | NOT NULL |\n| `email` | VARCHAR(255) | UNIQUE, NOT NULL |\n| `class` | VARCHAR(20) | NOT NULL |\n| `created_at` | TIMESTAMP | DEFAULT NOW() |\n\n**Relationships:**\n- One student → Many enrollments\n- Foreign key: `enrollments.student_id → students.id`\n:::\n',
    },
  ],
};

// ── LIFECYCLE GROUP ───────────────────────────────────────────────────────────
export const GROUP_LIFECYCLE = {
  key: 'lifecycle', label: 'Life Cycles', icon: IC.lifecycle,
  items: [
    {
      label: 'Life Cycle (Custom)', title: 'Custom Life Cycle Builder',
      insert: '\n:::lifecycle\ntitle=Life Cycle of [Organism Name]\ncircular=true\n1. Stage 1 Name | 🥚 | \n2. Stage 2 Name | 🐛 | \n3. Stage 3 Name | 🦋 | \n4. Stage 4 Name | 🌟 | \n:::\n',
    },
    {
      label: 'Butterfly', title: 'Butterfly Life Cycle',
      insert: '\n:::lifecycle\ntitle=Life Cycle of a Butterfly (Holometabolism)\ncircular=true\n1. Egg | 🥚\n2. Larva (Caterpillar) | 🐛\n3. Pupa (Chrysalis) | 🫘\n4. Adult Butterfly | 🦋\n:::\n',
    },
    {
      label: 'Frog', title: 'Frog Life Cycle',
      insert: '\n:::lifecycle\ntitle=Life Cycle of a Frog\ncircular=true\n1. Egg (Spawn) | 🥚\n2. Tadpole | 🐟\n3. Tadpole with Hind Legs | 🐠\n4. Froglet | 🐸\n5. Adult Frog | 🐸\n:::\n',
    },
    {
      label: 'Mosquito', title: 'Mosquito Life Cycle',
      insert: '\n:::lifecycle\ntitle=Life Cycle of Mosquito (Aedes aegypti)\ncircular=true\n1. Egg | 🥚\n2. Larva | 🪱\n3. Pupa | 🫘\n4. Adult Mosquito | 🦟\n:::\n',
    },
    {
      label: 'Plant', title: 'Flowering Plant Life Cycle',
      insert: '\n:::lifecycle\ntitle=Life Cycle of a Flowering Plant\ncircular=true\n1. Seed | 🌰\n2. Germination | 🌱\n3. Seedling | 🌿\n4. Mature Plant | 🌳\n5. Flower | 🌸\n6. Pollination | 🐝\n7. Fruit / Seed Formation | 🍎\n:::\n',
    },
    {
      label: 'Cockroach', title: 'Cockroach Life Cycle (Incomplete Metamorphosis)',
      insert: '\n:::lifecycle\ntitle=Life Cycle of Cockroach (Paurometabolism)\ncircular=true\n1. Egg (Ootheca) | 🥚\n2. Nymph (1st instar) | 🪳\n3. Nymph (intermediate instars) | 🪳\n4. Adult Cockroach | 🪳\n:::\n',
    },
    {
      label: 'Water Cycle', title: 'Water Cycle (Earth Science)',
      insert: '\n:::lifecycle\ntitle=The Water Cycle (Hydrological Cycle)\ncircular=true\n1. Evaporation | ☀️\n2. Condensation | ☁️\n3. Precipitation | 🌧️\n4. Surface Runoff | 🏞️\n5. Infiltration & Groundwater | 🌊\n:::\n',
    },
    {
      label: 'Carbon Cycle', title: 'Carbon Cycle',
      insert: '\n:::lifecycle\ntitle=The Carbon Cycle\ncircular=true\n1. Photosynthesis (CO₂ absorbed) | 🌿\n2. Carbon stored in biomass | 🌳\n3. Respiration / Decomposition | 🍂\n4. CO₂ released to atmosphere | 💨\n5. Ocean absorption | 🌊\n:::\n',
    },
    {
      label: 'Rock Cycle', title: 'Rock Cycle (Geography)',
      insert: '\n:::lifecycle\ntitle=The Rock Cycle\ncircular=true\n1. Igneous Rock (cooling of magma) | 🌋\n2. Weathering & Erosion | 💨\n3. Sediment deposition | 🏖️\n4. Sedimentary Rock (compaction) | 🪨\n5. Heat & Pressure | 🔥\n6. Metamorphic Rock | 💎\n7. Melting → Magma | 🌋\n:::\n',
    },
    {
      label: 'Cell Cycle', title: 'Cell Cycle (Biology)',
      insert: '\n:::lifecycle\ntitle=The Cell Cycle\ncircular=true\n1. G1 Phase (cell growth) | 📈\n2. S Phase (DNA replication) | 🧬\n3. G2 Phase (preparation) | ⚙️\n4. Mitosis / M Phase (division) | 🔬\n5. Cytokinesis (cytoplasm splits) | ✂️\n:::\n',
    },
    {
      label: 'Nitrogen Cycle', title: 'Nitrogen Cycle',
      insert: '\n:::lifecycle\ntitle=The Nitrogen Cycle\ncircular=true\n1. N₂ in atmosphere | 💨\n2. Nitrogen fixation (bacteria) | 🦠\n3. Nitrification (NH₃ → NO₃⁻) | 🌱\n4. Assimilation by plants | 🌿\n5. Consumption by animals | 🐄\n6. Decomposition | 🍂\n7. Denitrification → N₂ | 💨\n:::\n',
    },
  ],
};

// ── SPECIAL INSERTS GROUP (image/video/button/color) ─────────────────────────
export const GROUP_SPECIAL = {
  key: 'special', label: 'Media & Style', icon: IC.palette,
  items: [], // These trigger modals — handled separately
};

// ── FULL TOOLBAR GROUPS ARRAY (order for the toolbar) ────────────────────────
// Keep only the general-purpose writing tools in the toolbar. The subject packs
// (Math, Chemistry, Physics, Biology, Life Cycles, General, Exam Prep, CS) are
// still exported above if we ever want to bring them back.
export const TOOLBAR_GROUPS = [
  GROUP_FORMAT,
  GROUP_BLOCKS,
];